<template>
	<div>
		<b-container>
			<b-row>
				<b-col style="text-align: right;">
					<b-button variant="link" @click="edit()">
						{{ editButtonText }}
					</b-button>
				</b-col>
			</b-row>

			<b-row v-for="(program, index) in displayDataEdit" :key="program.id">
				<b-col>
					<program-type-view
						:index="index"
						:program="program"
						:mode="editMode"
						class="program-view"
						@remove="refresh()"
					/>
					<div v-if="index !== displayDataEdit.length" style="height: 15px;" />
				</b-col>
			</b-row>

			<b-row v-if="!displayDataEdit || !displayDataEdit.length">
				<b-col>
					<div class="empty-content">
						No program types to display
					</div>
				</b-col>
			</b-row>

			<b-row v-if="editMode && displayDataEdit && displayDataEdit.length > 0">
				<b-col>
					<b-button block @click="add()">
						Add Program
					</b-button>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ProgramTypeView from './ProgramTypeView.vue';

export default {
	name: 'AssetProgram',
	components: {ProgramTypeView},
	filters: {},
	props: {},
	data() {
		return {
			editMode: false,
			editButtonText: 'Add',
			displayDataEdit: {}
		};
	},
	computed: {
		...mapState(['elementEditorEntityDataId']),
	},
	watch: {
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		}
	},
	created() {
		
	},
	mounted() {
	},
	methods: {
		async add() {
			const newProgram = {
				category: "",
				type: "",
				description: "",
				asOfDate: null,
				floorArea: 0,
				pctOfAssetFloorArea: 0,
				unitCount: 0,
				pctOfAssetUnits: 0,
				rentableArea: 0,
				usableArea: 0,
				rentableUsableFactor: 0,
				entityId: this.elementEditorEntityDataId
			}
			const postAssetProgramModelData = await this.axios.post(
				`/assetprograms`,
				newProgram
			);
			this.getData();
			this.editMode = true;
		},
		edit() {
			if (this.displayDataEdit !== null && this.displayDataEdit.length > 0) {
				this.editMode = !this.editMode;
			} else {
				this.add();
			}
		},
		refresh() {
			this.getData();
			this.editMode = true;
		},
		async getData() {
			const assetprogramData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetprograms`
			);
			this.displayDataEdit = assetprogramData.data;
			if (this.displayDataEdit !== null && this.displayDataEdit.length > 0) {
				this.editButtonText = 'Edit'
			} else {
				this.editButtonText = 'Add'
			}
		}
	},
};
</script>

<style scoped>
.empty-content {
	display: flex;
	justify-content: center; 
	align-items: center;
	padding: 30px;
}
</style>
<style scoped>
div.program-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #ffffff;
}
</style>